// 转股的基础路径
export const PARTIAL_ACATS_BASE_PATH = '/profile/transfer/step';
